import React from 'react';
import styled from 'styled-components';

import { Box as BaseBox } from 'Components/Base';

const MAX_WIDTH = '1280px';
const MAX_HEIGHT = '720px';
const MIN_HEIGHT = '200px';

const Box = styled((props) => <BaseBox {...props} />)`
  position: relative;
  &::before {
    content: '';
    height: 0;
    display: block;
    padding-bottom: ${({ ratio }) => `calc(100% / ${ratio})`};
  }
  & > * {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
`;

const NoteBoardWrapper = ({ children, ...restProps }) => {
  return (
    <Box
      mx={'auto'}
      ratio={16 / 9}
      maxHeight={MAX_HEIGHT}
      minHeight={MIN_HEIGHT}
      maxWidth={MAX_WIDTH}
      {...restProps}
    >
      {children}
    </Box>
  );
};

export default NoteBoardWrapper;
